import { PlusLarge, PlusXSmall, } from '@wix/wix-ui-icons-common/on-stage/system';
import { Plus, PlusSmall } from '@wix/wix-ui-icons-common/on-stage';
export const theme = (className) => ({
    className,
    icons: {
        AddItemButton: {
            tiny: PlusXSmall,
            small: PlusSmall,
            medium: Plus,
            large: PlusLarge,
            image: null,
        },
    },
});
//# sourceMappingURL=WSRTheme.js.map